const ActionNameConstants = {
    /**
     * Check in action
     */
    CheckIn: 'TXPCheckIn',

    /**
     * Confirm reservation action
     */
    ConfirmReservation: 'TXPConfirmReservation',

    /**
     * Track package action
     */
    TrackPackage: 'TXPTrackPackage',

    /**
     * Modify reservation action
     */
    ModifyReservation: 'TXPModifyReservation',

    /**
     * Pay bill action
     */
    PayBill: 'TXPPayBill',
};

export default ActionNameConstants;
